"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Card = (0, _react.memo)(({
  icon,
  title,
  description,
  actions,
  className
}) => _react.default.createElement(_styles.SContainer, {
  className: className
}, _react.default.createElement(_styles.SHeader, null, _react.default.createElement(_styles.SIconBox, null, icon)), _react.default.createElement(_styles.SBody, null, _react.default.createElement(_styles.STitle, null, title), _react.default.createElement(_styles.SDescription, null, description)), _react.default.createElement(_styles.SFooter, null, _react.default.Children.toArray(actions))));
Card.propTypes = {
  icon: _propTypes.default.element.isRequired,
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  actions: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  className: _propTypes.default.string
};
var _default = exports.default = Card;